module.exports = __webpack_public_path__ + "media/images/proposal/top/feature-detail-background-bc3d5c3106b2c49077b9e02f4a3ddfca.jpg";